import isNil from 'lodash/isNil';

import { FilterHierarchy, FilterRange, FilterTerms, SearchFilterValue } from '../model';

export const isFilterTerms = (filter?: SearchFilterValue): filter is FilterTerms => !!filter && Array.isArray(filter);

export const isFilterRange = (filter?: SearchFilterValue): filter is FilterRange =>
    !isNil((filter as FilterRange)?.gte) && !isNil((filter as FilterRange)?.lte);

export const isFilterHierarchy = (filter?: SearchFilterValue): filter is FilterHierarchy =>
    !isNil((filter as FilterHierarchy)?.level) && !isNil((filter as FilterHierarchy)?.terms);
